// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'shared/components/Icon';
import UserDropdown from '../UserDropdown';
import styles from './TopNav.module.scss';

/** @typedef {{
  title: string,
  onHamburgerClick: () => any
}} TopNavPropsType */

/** @type { React.ValidationMap<TopNavPropsType> } */
const propTypes = {
  title: PropTypes.string,
  onHamburgerClick: PropTypes.func,
};

const TopNav = ({ title, onHamburgerClick }) => (
  <div className="level is-mobile">
    <div className="level-left">
      <div className={cx('level-item', styles.hamburger_container)} onClick={onHamburgerClick}>
        <Icon name="menu" />
      </div>
      <div className={cx('level-item', styles.page_title_container)}>
        <h1 className={styles.page_title}>{title}</h1>
      </div>
    </div>
    <div className="level-right">
      <UserDropdown />
    </div>
  </div>
);

TopNav.displayName = 'TopNav';
TopNav.propTypes = propTypes;

export default TopNav;
